import { createSelector } from 'reselect';

export default createSelector(
    state => state.seat_selection.workflow,
    ({ ticketTypes, ticketTypeOnFocus }) => {
        if (!ticketTypeOnFocus) {
            return null;
        }

        const ticketType = ticketTypes?.find(type => type.id === ticketTypeOnFocus.id);
        return ticketType?.sectors_ids;
    },
);
